<template>
  <section class="[ color-palette-swatch-selector ] rounded-md border border-white/15 bg-white/5 px-3 py-3">
    <div class="mb-2 flex items-center justify-between gap-2">
      <p class="text-xs font-bold uppercase tracking-wide text-pink-200">{{ label }}</p>
      <div class="text-xs text-pink-300">
        {{ selectedColorLabel }}
      </div>
    </div>

    <div class="grid grid-cols-8 gap-2">
      <button
        v-if="allowNone"
        type="button"
        class="flex h-8 w-8 items-center justify-center rounded-full border text-xs transition-all duration-150"
        :class="modelValue == null ? 'border-white/80 bg-white/10 text-white' : 'border-transparent bg-white/5 text-pink-100 hover:border-white/30'"
        title="No color"
        @click="$emit('update:modelValue', null)"
      >
        <span class="leading-none">-</span>
      </button>

      <button
        v-for="color in normalizedColors"
        :key="`palette-color-${color.id}`"
        type="button"
        class="h-8 w-8 rounded-full border transition-all duration-150"
        :class="[
          modelValue === color.id ? 'border-white/80 scale-110' : 'border-transparent hover:border-white/30',
          usedValueIds.includes(color.id) && modelValue !== color.id ? 'opacity-60' : ''
        ]"
        :style="{ backgroundColor: color.hex }"
        :title="`${color.name}${usedValueIds.includes(color.id) ? ' (in use)' : ''}`"
        @click="$emit('update:modelValue', color.id)"
      />
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

defineOptions({ name: 'ColorPaletteSwatchSelector' });

const props = defineProps({
  modelValue: {
    type: Number,
    default: null
  },
  colors: {
    type: Array,
    default: () => []
  },
  label: {
    type: String,
    default: 'Select Color'
  },
  allowNone: {
    type: Boolean,
    default: false
  },
  usedValueIds: {
    type: Array,
    default: () => []
  }
});

defineEmits(['update:modelValue']);

const normalizedColors = computed(() => {
  return (Array.isArray(props.colors) ? props.colors : [])
    .map((color) => ({
      id: Number(color?.id),
      hex: String(color?.hex || '').trim(),
      name: String(color?.name || `Color ${color?.id ?? ''}`).trim()
    }))
    .filter((color) => Number.isFinite(color.id) && color.hex);
});

const selectedColorLabel = computed(() => {
  if (props.modelValue == null) {
    return props.allowNone ? 'No color selected' : 'No color selected';
  }

  const match = normalizedColors.value.find((color) => color.id === Number(props.modelValue));
  return match?.name || 'No color selected';
});
</script>
